import { PurchaseHistorySavePageProps } from 'src/pages/PurchaseHistoryPage/PurchaseHistorySavePage/index'
import styled from 'styled-components'
import { Container } from 'src/components/common/Container'
import {
  Noto_body1_b16,
  Noto_body1_r16,
  Noto_body2_b14,
  Noto_body2_r14,
} from 'src/styles/fonts/NotoSansKrFonts'
import { Typography } from 'src/components/common/Typography'
import { layoutMaxSize } from 'src/styles/mixin'
import { Icon } from 'src/assets/svg/Icon'

const PurchaseHistorySavePageView = (props: PurchaseHistorySavePageProps) => {
  const { isPassCert, passCertRequest } = props

  return (
    <S.PurchaseHistorySaveWrap $option="flex_column">
      <S.PurchaseHistorySaveButton
        $isPassCert={isPassCert}
        disabled={isPassCert}
        onClick={() => passCertRequest(0)}
      >
        <S.SaveButtonLeftText $fontStyle={Noto_body2_r14}>구매내역 저장</S.SaveButtonLeftText>
        <S.SaveButtonRightText
          $fontStyle={Noto_body2_b14}
          $color={isPassCert ? 'var(--brand-50)' : 'var(--black-70)'}
        >
          {isPassCert ? (
            <>
              저장 완료
              <Icon.BlueCheck />
            </>
          ) : (
            <>
              미완료
              <Icon.Arrow size="16" rotate="right" color="var(--black-70)" />
            </>
          )}
        </S.SaveButtonRightText>
      </S.PurchaseHistorySaveButton>
      <S.PurchaseHistorySaveInfo $option="flex_column" $row_gap="10px">
        <S.InfoTitle>구매 내역 저장이란?</S.InfoTitle>
        <S.InfoDetail>
          <span>1.</span>
          <span>
            한 번의 저장으로 서비스 해지 후에도 휴대폰쿠폰지갑에서 본인이 구매한 쿠폰 내역이
            안전하게 보관됩니다.
          </span>
          <span>2.</span>
          <span>
            서비스 재가입 시 구매 내역 저장을 통해 이전에 저장해 놓은 쿠폰을 불러올 수 있습니다.
          </span>
          <span>3.</span>
          <span>
            저장을 완료하지 않은 계정의 구매내역은 서비스 해지 시 복원이 어려울 수 있습니다.
          </span>
        </S.InfoDetail>
      </S.PurchaseHistorySaveInfo>
    </S.PurchaseHistorySaveWrap>
  )
}
export default PurchaseHistorySavePageView

const S = {
  PurchaseHistorySaveWrap: styled(Container)`
    ${layoutMaxSize};
    background-color: var(--white);
    margin: 0 auto;
    padding: 0 20px;
    height: 100%;
  `,
  PurchaseHistorySaveButton: styled.button<{ $isPassCert: boolean }>`
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
    padding: 10px;
    border-radius: 12px;
    background-color: ${({ $isPassCert }) => ($isPassCert ? 'var(--brand-5)' : 'var(--black-6)')};
  `,
  SaveButtonLeftText: styled(Typography)`
    padding: 0 10px;
  `,
  SaveButtonRightText: styled(Typography)`
    ${Noto_body2_b14};
    display: flex;
    align-items: center;
    gap: 2px;
  `,
  PurchaseHistorySaveInfo: styled(Container)`
    padding: 16px;
    border: 1px solid var(--black-10);
    border-radius: 12px;
    color: var(--black-50);
  `,
  InfoTitle: styled(Typography)`
    ${Noto_body1_b16}
  `,
  InfoDetail: styled(Container)`
    ${Noto_body1_r16};
    display: grid;
    grid-template-columns: 20px auto;
  `,
}
